package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.selectors.hover
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba

val LinearGradientStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(Colors.secondary)
            .backgroundImage(
                linearGradient(
                    from = Color.white,
                    to = Colors.secondary,
                    dir = LinearGradient.Direction.ToBottom
                )
            )
            .color(Color.transparent)

            .then(
                Modifier.styleModifier {
                    property("background-size", "cover")
                    property("background-repeat", "no-repeat")
                }
            )
    }
}

val ModelImageStyle = CssStyle {
    base {
        Modifier
            .height(300.px)
            .objectFit(ObjectFit.Cover)
            .boxShadow(color = Color.transparent)
            .transition {
                duration(800.ms)
                timingFunction(TransitionTimingFunction.cubicBezier(0.2, 1.20, 0.2, 1.0))
            }
    }
    Breakpoint.MD { Modifier.height(380.px) }
    Breakpoint.LG { Modifier.height(420.px) }
    Breakpoint.XL { Modifier.height(480.px) }

    hover {
        Modifier
            .scale(1.15)
            .styleModifier { property("filter", "blur(0.3px)") }
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 10.px,
                spreadRadius = 2.px,
                color = rgba(0, 1, 6, 0.1)
            )
    }
}

val ChooseModelStyle = CssStyle {

    base {
        Modifier
            .width(340.px)
            .height(490.px)
            .styleModifier {
                property("object-fit", "cover")
            }
            .objectFit(ObjectFit.Cover)
            .transition {
                duration(800.ms)
                timingFunction(TransitionTimingFunction.cubicBezier(0.2, 1.20, 0.2, 1.0))
            }
    }

    Breakpoint.MD {
        Modifier
            .width(330.px)
            .height(460.px)
    }

    Breakpoint.LG {
        Modifier.width(280.px).height(400.px)
    }
    Breakpoint.XL {
        Modifier.width(330.px).height(480.px)
    }

    hover {
        Modifier
            .scale(1.04)
            .styleModifier {
                property("filter", "blur(0.3px)")
            }
            .boxShadow(
                offsetX = 0.px,
                offsetY = 15.px,
                blurRadius = 30.px,
                color = rgba(0, 0, 0, 0.4)
            )
    }
}

val ModelCvStyle = CssStyle {
    base {
        Modifier
            .height(480.px)
            .objectFit(ObjectFit.Cover)
            .boxShadow(color = Color.transparent)
            .transition {
                property("transition")
                duration(300.ms)
            }
    }

    hover {

        Modifier
            .scale(1.01)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 2.px,
                blurRadius = 10.px,
                spreadRadius = 2.px,
                color = rgba(0, 1, 6, 0.1)
            )
    }
}

val AccordionRowStyle = CssStyle {
    base {
        Modifier
            .transition {
                property("background-color")
                duration(300.ms)
                timingFunction(TransitionTimingFunction.cubicBezier(0.44, 0.0, 0.56, 1.0))
            }
    }
    hover {
        Modifier
            .backgroundColor(Colors.White.copy(alpha = 50))
    }
}
val ModelSectionStyle = CssStyle {
    base          { Modifier.margin(top = 30.px, bottom = 25.px).padding(topBottom = 20.px) }
    Breakpoint.MD { Modifier.margin(top = 60.px, bottom = 40.px).padding(topBottom = 40.px) }
}

val ModelSectionTitleStyle = CssStyle {
    base          { Modifier.fontSize(20.px).margin(bottom = 20.px) }
    Breakpoint.MD { Modifier.fontSize(38.px).margin(bottom = 50.px) }
}

val ViewButtonWrapperStyle = CssStyle {
    base          { Modifier.margin(top = 15.px) }
    Breakpoint.MD { Modifier.margin(top = 30.px) }
}

val CarouselWrapperStyle = CssStyle {
    base          { Modifier.margin(bottom = 10.px) }
    Breakpoint.MD { Modifier.margin(bottom = 20.px) }
}

val MeatballContainerStyle = CssStyle {
    base          { Modifier.padding(leftRight = 8.px, topBottom = 6.px) }
    Breakpoint.MD { Modifier.padding(leftRight = 10.px, topBottom = 10.px) }
}

val ChevronButtonStyle = CssStyle {
    base          {
        Modifier.size(30.px)
    }
    Breakpoint.MD {
        Modifier.size(40.px)
    }

}

val ChevronImageStyle = CssStyle {
    base          { Modifier.fontSize(20.px) }
    Breakpoint.MD { Modifier.fontSize(30.px) }
}

val ChevronLeftPositionStyle = CssStyle {
    base          { Modifier.left(60.px) }
    Breakpoint.MD { Modifier.left(10.px) }
}

val ChevronRightPositionStyle = CssStyle {
    base          { Modifier.right(60.px) }
    Breakpoint.MD { Modifier.right(10.px) }
}

val MeatballRowStyle = CssStyle {
    base          { Modifier.gap(6.px) }
    Breakpoint.MD { Modifier.gap(12.px) }
}

val MeatballDotStyle = CssStyle {
    base          { Modifier.size(7.px) }
    Breakpoint.MD { Modifier.size(10.px) }
}

val ViewButtonStylecss = CssStyle {
    base          { Modifier.fontSize(14.px).padding(topBottom = 15.px, leftRight = 10.px) }
    Breakpoint.MD { Modifier.fontSize(30.px).padding(topBottom = 40.px, leftRight = 35.px) }
}

val ViewButtonArrowStyle = CssStyle {
    base          { Modifier.fontSize(20.px) }
    Breakpoint.MD { Modifier.fontSize(30.px) }
}

